<template>
  <div class="popup_list">
    <div class="wrap">
      <youtube :video-id="videoId" :player-width="youtubeWidth" :player-height="youtubeHeight" class="youtube"/>
    </div>
    <a class="overlay" @click="closePopup('')"/>
  </div>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      default: '',
      Android : navigator.userAgent.match(/Android/i)
    }
  },
  mounted() {},
  methods: {
    closePopup(data) {
      this.$emit('close', data)
    }
  },
  computed: {
    youtubeWidth () {
      const Android = navigator.userAgent.match(/Android/i);
      const iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
      if (Android !== null || iOS !== null) {
        return "320"
        
      } else {
        return "960"
      }
    },
    youtubeHeight () {
      const Android = navigator.userAgent.match(/Android/i);
      const iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
      if (Android !== null || iOS !== null) {
        return "180"
      } else {
        return "540"
      }
    }
  }
}
</script>

<style scoped>
@import "./styles/youtubePop.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/YoutubePop.vue